import { useMemo } from "react";
import { useAddinData } from "../addins/useAddinData";
import { viewOverrideId } from "./viewOverrideId";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { PAGE_CONFIGS, PageType } from "@/constants/PageType";
import { ViewOverride } from "@/models/DiagnosticView";

export function useViewOverride(pageType: PageType, viewId: string | null) {
  const { me } = useGeotabClient();
  const addInId = PAGE_CONFIGS[pageType].addInId;
  const { data: rows = [], ...rest } = useAddinData<ViewOverride>(addInId);

  const override = useMemo(() => {
    if (!viewId || !me?.id) return null;
    const expectedId = viewOverrideId(me.id, viewId);
    return rows.find(r => r.id === expectedId) ?? null;
  }, [rows, viewId, me?.id]);

  return { override, ...rest };
}
